import {
  PROJECT_RESOURCE,
  type ProjectResource,
} from 'hooks/useProjectResources';

export const BUILD_NAVIGATION_RESOURCES = [
  PROJECT_RESOURCE.KNOWLEDGE_BASE,
  PROJECT_RESOURCE.VARIANT_MANAGEMENT,
  PROJECT_RESOURCE.AGENT,
  PROJECT_RESOURCE.RULES,
  PROJECT_RESOURCE.HANDOFFS,
  PROJECT_RESOURCE.SMS,
  PROJECT_RESOURCE.FLOWS,
  PROJECT_RESOURCE.FUNCTIONS,
  PROJECT_RESOURCE.AS_API_INTEGRATIONS,
  PROJECT_RESOURCE.REALTIME_CONFIG_MANAGER,
  PROJECT_RESOURCE.TEST_SUITE,
  PROJECT_RESOURCE.SOURCE_HUB,
  PROJECT_RESOURCE.LANGUAGE_HUB,
];

export const CONFIGURE_NAVIGATION_RESOURCE = [
  PROJECT_RESOURCE.SETTINGS,
  PROJECT_RESOURCE.ENVIRONMENTS,
  PROJECT_RESOURCE.CUSTOM_METRICS,
  PROJECT_RESOURCE.NUMBERS,
  PROJECT_RESOURCE.INTEGRATIONS,
  PROJECT_RESOURCE.CSAT,
];

export const MANAGE_RESOURCES = [
  PROJECT_RESOURCE.HOME,
  PROJECT_RESOURCE.CONVERSATIONS,
  PROJECT_RESOURCE.ASSISTANT_ANALYSIS,
  PROJECT_RESOURCE.SMART_ANALYST,
  PROJECT_RESOURCE.SAFETY_ANALYTICS,
];

export const DASHBOARD_RESOURCES = [
  PROJECT_RESOURCE.ANALYTICS,
  PROJECT_RESOURCE.CUSTOM_ANALYTICS,
];

export const VOICE_NAVIGATION_RESOURCES = [
  PROJECT_RESOURCE.VOICE,
  PROJECT_RESOURCE.RESPONSE_CONTROL,
  PROJECT_RESOURCE.AUDIO_MANAGEMENT,
  PROJECT_RESOURCE.SPEECH_RECOGNITION,
];

export const CHANNEL_NAVIGATION_RESOURCES = [
  PROJECT_RESOURCE.VOICE_CHANNEL,
  PROJECT_RESOURCE.WEBCHAT_CHANNEL,
];

export const BUILDER_NAVIGATION_RESOURCES: ProjectResource[] = [
  ...BUILD_NAVIGATION_RESOURCES,
  ...VOICE_NAVIGATION_RESOURCES,
];

export const MANAGER_NAVIGATION_RESOURCES: ProjectResource[] = [
  ...MANAGE_RESOURCES,
  ...DASHBOARD_RESOURCES,
  PROJECT_RESOURCE.AGENT_CONFIG,
  PROJECT_RESOURCE.CUSTOM_METRICS,
];

// New IA 2025 navigation resource arrays

export const ANALYTICS_NAVIGATION_RESOURCES = [
  ...MANAGE_RESOURCES,
  ...DASHBOARD_RESOURCES,
];

export const NEW_BUILD_NAVIGATION_RESOURCES = [
  PROJECT_RESOURCE.KNOWLEDGE_BASE,
  PROJECT_RESOURCE.VARIANT_MANAGEMENT,
  PROJECT_RESOURCE.AGENT,
  PROJECT_RESOURCE.RULES,
  PROJECT_RESOURCE.HANDOFFS,
  PROJECT_RESOURCE.SMS,
  PROJECT_RESOURCE.FLOWS,
  PROJECT_RESOURCE.FUNCTIONS,
  PROJECT_RESOURCE.REALTIME_CONFIG_MANAGER,
  PROJECT_RESOURCE.TEST_SUITE,
  PROJECT_RESOURCE.SOURCE_HUB,
  PROJECT_RESOURCE.LANGUAGE_HUB,
];

export const CHANNELS_NAVIGATION_RESOURCES = [
  ...VOICE_NAVIGATION_RESOURCES,
  ...CHANNEL_NAVIGATION_RESOURCES,
];

export const SETTINGS_NAVIGATION_RESOURCES = [
  PROJECT_RESOURCE.SETTINGS,
  PROJECT_RESOURCE.NUMBERS,
  PROJECT_RESOURCE.AS_API_INTEGRATIONS,
  PROJECT_RESOURCE.INTEGRATIONS,
  PROJECT_RESOURCE.CUSTOM_METRICS,
  PROJECT_RESOURCE.CSAT,
  PROJECT_RESOURCE.REALTIME_CONFIG_BUILDER,
];
